import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Popup } from '../../utils/popups';
import { FormPopup } from './FormPopup';
function InfoPopup({ title, children = 'Coming soon!', reject, resolve, width, noOk = false, }) {
    const okButtonProps = noOk
        ? undefined
        : {
            label: 'Ok',
            onClick: () => {
                resolve();
            },
        };
    return (_jsx(InfoPopupRoot, { "$width": width, title: title, reject: reject, canSubmit: true, okButtonProps: okButtonProps, children: _jsx(Content, { children: children }) }));
}
const Content = styled.div `
    line-height: 1.4rem;
    padding: 1.5rem;
    padding-top: 0;

    ul, ol {
        list-style: disc;
        list-style-position: outside;
        padding-left: 1.25rem;
    }

    ol {
        list-style: lower-alpha;
    }

    * + p,
    * + ul,
    * + ol {
        margin-top: 0.75rem;
    }

    li + li {
        margin-top: 0.375rem;
    }

    a {
        color: inherit !important;
        text-decoration: underline;
    }

    h2 {
        font-weight: 600;
        font-size: 1.25rem;
        margin: 2rem 0 1rem;
    }

    strong {
        font-weight: 600;
    }
`;
const InfoPopupRoot = styled(FormPopup) `
    @media (min-width: 30rem) {
        --Popup_Width: ${({ $width }) => $width};
    }
`;
const infoPopup = Popup.create(InfoPopup);
export function info({ title, children, width = '38rem', noOk, } = {}) {
    (async () => {
        try {
            await infoPopup.pop({ title, children, width, noOk });
        }
        catch (_) { }
    })();
}
export function about() {
    info({
        title: 'About',
        children: (_jsxs(_Fragment, { children: [_jsx("p", { children: "StreamrTV generates secure, peer-to-peer broadcasts using streams on the decentralized Streamr Network." }), _jsx("p", { children: "Your raw camera data is first protected with end-to-end encryption for privacy. This encrypted byte stream then travels through the interconnected mesh of viewers, which provides redundancy and resilience." }), _jsx("p", { children: "As each new viewer joins the stream, they provide more bandwidth and new connection paths for the next viewer, allowing the broadcast to autoscale for free, without limits." })] })),
    });
}
export function help() {
    info({
        title: 'Help',
        children: (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["If you experience any issues with StreamrTV, please report them on the", ' ', _jsx("a", { href: "https://discord.gg/gZAm8P7hK8", target: "_blank", rel: "noopener noreferrer", children: "Streamr Discord" }), ". StreamrTV is built on peer-to-peer technology, so performance may vary depending on your environment. Here are some common issues you might\u00A0encounter:"] }), _jsxs("ul", { children: [_jsxs("li", { children: [_jsx("strong", { children: "Outdated browser or operating system" }), ": StreamrTV will alert you if your browser or OS isn't supported. We're working to expand compatibility, but for now, browsers like Firefox and older operating systems are not\u00A0supported."] }), _jsxs("li", { children: [_jsx("strong", { children: "Restrictive WiFi networks" }), ": Some networks\u2014such as those in offices, hotels, or conference venues\u2014may block WebSocket connections, which are required to connect to the Streamr Network. If this happens, try switching to mobile\u00A0data."] }), _jsxs("li", { children: [_jsx("strong", { children: "Limited upload bandwidth" }), ": HD broadcasting requires a stable upload speed of at least 15 Mbps. If your connection is slower, consider switching your stream to SD in the settings\u00A0menu."] })] })] })),
    });
}
